import { render, staticRenderFns } from "./EventOverviewRowSkeletonMobile.vue?vue&type=template&id=2bc80299&scoped=true&functional=true"
var script = {}
import style0 from "./EventOverviewRowSkeletonMobile.vue?vue&type=style&index=0&id=2bc80299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2bc80299",
  null
  
)

export default component.exports